import * as React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const StrikeIcon = ({ sx }) => (
  <SvgIcon sx={sx} viewBox="0 0 16 20">
    <path
      d="M4.3131 4.43546C5.41363 3.70011 6.70751 3.30762 8.03111 3.30762C8.90995 3.30762 9.78018 3.48072 10.5921 3.81703C11.4041 4.15335 12.1418 4.6463 12.7632 5.26773C13.3847 5.88916 13.8776 6.62691 14.2139 7.43885C14.5503 8.25079 14.7233 9.12102 14.7233 9.99986C14.7233 11.3235 14.3309 12.6173 13.5955 13.7179C12.8602 14.8184 11.815 15.6762 10.5921 16.1827C9.36927 16.6892 8.02369 16.8217 6.72552 16.5635C5.42735 16.3053 4.23491 15.6679 3.29898 14.732C2.36306 13.7961 1.72568 12.6036 1.46746 11.3054C1.20924 10.0073 1.34177 8.66169 1.84829 7.43885C2.35481 6.216 3.21257 5.17082 4.3131 4.43546Z"
      fill="#B23E3E"
    />
    <path
      d="M10.536 8.32145C10.7644 8.09311 10.7644 7.72291 10.536 7.49457C10.3077 7.26624 9.93748 7.26624 9.70915 7.49457L8.03043 9.17329L6.35164 7.49449C6.1233 7.26616 5.7531 7.26616 5.52477 7.49449C5.29643 7.72283 5.29643 8.09303 5.52477 8.32136L7.20356 10.0002L5.52481 11.6789C5.29647 11.9072 5.29647 12.2774 5.52481 12.5058C5.75314 12.7341 6.12334 12.7341 6.35168 12.5058L8.03043 10.827L9.7091 12.5057C9.93744 12.734 10.3076 12.734 10.536 12.5057C10.7643 12.2774 10.7643 11.9072 10.536 11.6788L8.8573 10.0002L10.536 8.32145Z"
      fill="white"
    />
  </SvgIcon>
);

StrikeIcon.propTypes = {
  sx: PropTypes.shape({}),
};

export default StrikeIcon;
